import ButtonStyler from "./Button.style";

function Button(props) {
  return (
    <button
      className={props.className}
      onClick={props.onClick}
    >
    Delete
    </button>
  );
}

export default ButtonStyler(Button);
